import { render } from "./ComponenteResultadoEconomico.vue?vue&type=template&id=f060633e"
import script from "./ComponenteResultadoEconomico.vue?vue&type=script&lang=js"
export * from "./ComponenteResultadoEconomico.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__